import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store.ts";
import { userSlice } from "../../redux/slices/user.ts";
import { api } from "../../api";
import { useNavigate } from "react-router";

export const RedirectToLogin: React.FC = () => {
  /* Watches the state of authentication. If user is not authenticated anymore, redirects to login page */
  const dispatch = useAppDispatch();
  const { accessToken } = useAppSelector((state) => state[userSlice.name]);
  const { error } = api.endpoints.getCurrentUserInfoApiMeGet.useQuery(
    undefined,
    {
      skip: !accessToken,
    },
  );
  const navigate = useNavigate();

  React.useEffect(() => {
    const isAuthenticationError =
      error && "status" in error && error.status == 401;
    if (isAuthenticationError) {
      dispatch(userSlice.actions.setToken(null));
      api.util.resetApiState();
    }
    if (isAuthenticationError || !accessToken) {
      void navigate("/");
    }
  }, [accessToken, error, dispatch, navigate]);
  return null;
};
